<div class="div_container_waiter_table">
  <div class="w-100 d-flex flex-row">
    <div class="back-to-tables-btn-container w-40">
        <a *ngIf="(selectedCategory | json) == '{}'" (click)="goBack()" class="back-to-tables-btn">
          <i class="pi pi-arrow-left"></i></a>
        <a *ngIf="(selectedCategory | json) != '{}'" (click)="goBackToCategories()" class="back-to-tables-btn">
          <i class="pi pi-arrow-left"></i></a>
      <label class="wtr_venue_info_32 ellipsis ms-4">{{ venueName }}</label>
    </div>
    <div class="w-60 d-flex flex-row align-items-center">
      <input class="search_items_field"  placeholder="Search" [(ngModel)]="searchText" (ngModelChange)="filterResults()">
    </div>
  </div>
  <div class="table_order_container">
    <div class="menu_items">
      <div *ngIf="(selectedCategory | json) == '{}'">
        <div class="waiter_most_ordered_container mt-2" *ngIf="mostOrderedItems.length > 0">
          <label class="wtr-lbl-info m-4">{{'WAITER_CATEGORIES.MOST_ORDERED' | translate}}</label>
          <div class="div_card_waiter_most_ordered" *ngFor="let item of filteredMostOrderedItems">
              <img class="waiter_most_ordered_image" [src]="!item.pictureURL ? imagePath :item.pictureURL"
                alt="most-ordered-image">
              <span class="waiter_most_ordered_name">{{item.name}}</span>
          </div>
        </div>
      </div>
      <div>
        <ng-container *ngIf="(selectedCategory | json) == '{}'">
          <label class="wtr-lbl-info m-2">{{'WAITER_CATEGORIES.CATEGORIES' | translate}}</label>
          <div class="waiter_categories_container mt-2" *ngIf="filteredCategoriesList.length > 0">
            <div class="div_card_waiter_category" (click)="openCategory(category)" *ngFor="let category of filteredCategoriesList">
                <img class="waiter_category_image" [src]="!category.pictureURL ? imagePath : category.pictureURL"
                  alt="category-image">
                <span class="waiter_category_name">{{category.name}}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedCategory">
          <label class="wtr-lbl-info m-2">{{selectedCategory.name}}</label>
          <div class="waiter_menu_item_container" *ngFor="let item of filteredSelectedCategoryVenueMenuItems">
            <div class="div_card_waiter_menu_item" (click)="addToOrderItems(item)">{{item.name}}</div>
          </div>
          <div *ngIf="filteredSelectedCategoryChildVenueMenuCategories && filteredSelectedCategoryChildVenueMenuCategories.length > 0">
            <label class="wtr-lbl-info m-2">{{'WAITER_CATEGORIES.SUBCATEGORIES' | translate}}</label>
            <div class="waiter_categories_container">
              <div class="div_card_waiter_category" (click)="openCategory(subCategory)" *ngFor="let subCategory of filteredSelectedCategoryChildVenueMenuCategories">
                  <img class="waiter_category_image" [src]="!subCategory.pictureURL ? imagePath : subCategory.pictureURL"
                       alt="category-image">
                  <span class="waiter_category_name">{{subCategory.name}}</span>
            </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="table_items_display">
      <div class="items_list_header d-flex flex-row justify-content-between">
        <span>TABLE {{tableName}}</span> <span *ngIf="orderBillNumber">#{{orderBillNumber}}</span>
      </div>
      <div class="items_table_content_wrapper">
        <div class="list_item d-flex flex-row justify-content-between" *ngFor="let item of orderItemsQuantity | keyvalue">
          <span>{{item.value.venueMenuItemName}}</span><span>{{item.value.quantity}}</span>
        </div>
      </div>
      <div class="items_list_footer d-flex flex-row justify-content-end">
        {{'ORDER_DETAILS.TOTAL' | translate}} <ng-container *ngIf="totalPrice != undefined && currency">{{totalPrice  | customCurrencyPipe: currency.shortName :'1.0-2'}}</ng-container>
      </div>
      <div class="footer_wrapper">
        <div class="d-flex flex-row justify-content-between">
          <a class="add_note_link" (click)="addNote()">
            {{'ORDER.ADD_NOTE' | translate | uppercase}} <i class="pi pi-book ms-2"></i>
          </a>
          <span class="display_total">{{'ORDER_DETAILS.TOTAL' | translate}} <ng-container *ngIf="totalPriceWithTax != undefined && currency"> {{totalPriceWithTax | customCurrencyPipe: currency.shortName :'1.0-2'}}</ng-container> </span>
        </div>
        <div class="mt-2">
          <button class="create_order_btn ms-2 me-2" (click)="reviewOrderBeforeSaving()" [disabled]="(orderItemsQuantity | json) == '{}'">{{'ORDER.CREATE_ORDER' | translate}}</button>
          <button class="bill_btn ms-2" (click)="displayBill()" [disabled]="orderBillNumber == undefined">{{'ORDER_BILL.SHOW_BILL' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
